module.exports = __webpack_public_path__ + "static/media/Cube8_in.e5bb0b13.jpg";